import { useCallback, useRef } from 'react';

export const useScrollIntoView = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  const scrollIntoView = useCallback(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return { ref, scrollIntoView };
};
